// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NVvK","col":"styles_col__2G2Tb"};